export var getDefaultStyle = function getDefaultStyle(visible) {
  return {
    display: visible ? 'flex' : 'none'
  };
};